import "react-datepicker/dist/react-datepicker.css";
import {Constants} from "../common/Constants";

export let ActivityDirectionDisplay = function (props: {directionName: string, abbreviated?: boolean}) {
    let directionPointerSrc = '';
    let directionText = '';
    if (props.directionName === Constants.activityDirectionNames.inbound) {
        directionPointerSrc = "/static/images/direction-pointer-right-green.svg";
        directionText = props.abbreviated ? 'INBD' : 'INBOUND';
    } else {
        directionPointerSrc = "/static/images/direction-pointer-left-green.svg";
        directionText = props.abbreviated ? 'OTBD' : 'OUTBOUND';
    }

    return (
        <div className="activity-direction">
            <div className="activity-direction-pointer-box" >
                <img className="activity-direction-pointer" src={directionPointerSrc} />
            </div>
            <span className="activity-direction-text">{directionText}</span>
        </div>
    )
}